module.exports = __webpack_public_path__ + "assets/img/partnership.b8729f81.svg";